import api from './client';

const BASE = '/api/customers';

export async function fetchCustomers(params = {}, config = {}) {
  const { data } = await api.get(BASE, { params, ...config });
  return Array.isArray(data) ? data : [];
}

export async function fetchCustomerById(id, config = {}) {
  const { data } = await api.get(`${BASE}/${id}`, config);
  return data;
}

export async function lookupCustomerByPhone(phone, config = {}) {
  const { data } = await api.get(`${BASE}/by-phone`, { params: { phone }, ...config });
  return data;
}

export async function createCustomer(payload, config = {}) {
  const { data } = await api.post(BASE, payload, config);
  return data;
}

export async function updateCustomer(id, payload, config = {}) {
  const { data } = await api.put(`${BASE}/${id}`, payload, config);
  return data;
}

export async function deleteCustomer(id, config = {}) {
  await api.delete(`${BASE}/${id}`, config);
}
